import { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get("website_alt") as string || "").trim();
    if (honeypotValue) {
      setStatus("success");
      setMessage("Thank you for subscribing!");
      setEmail("");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch("https://readdy.ai/api/form/d9nl0cu8mbnljin5a2l0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          email: formData.get("email") as string,
        }).toString(),
      });

      const responseText = await res.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }

      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("Thank you for subscribing! You will receive the latest Vigorbuy Spreadsheet updates.");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "Something went wrong. Please try again.";
        setStatus("error");
        setMessage(serverMsg);
      }
    } catch {
      setStatus("error");
      setMessage("Network error. Please check your connection and try again.");
    }
  };

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100/70 text-primary-600 mx-auto mb-5">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          Stay Updated with <span className="text-primary-500">Vigorbuy Spreadsheet</span>
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
          Subscribe to receive the latest Vigorbuy spreadsheet product updates, new category additions, and expert shopping tips directly in your inbox.
        </p>

        <form
          data-readdy-form
          id="newsletter-form"
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            required
            className="flex-1 px-4 py-3 rounded-xl border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-website-alt-field"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {status === "loading" ? (
              <span className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin"></i>
                Subscribing...
              </span>
            ) : (
              <span>Subscribe</span>
            )}
          </button>
        </form>

        {message && (
          <div
            className={`mt-5 px-4 py-3 rounded-xl text-sm font-medium ${
              status === "success"
                ? "bg-primary-100/70 text-primary-700"
                : "bg-accent-100/70 text-accent-700"
            }`}
          >
            {message}
          </div>
        )}

        <p className="mt-4 text-xs text-foreground-300">No spam, unsubscribe anytime. We respect your privacy.</p>
      </div>
    </section>
  );
}